<template>
  <div class="h-100">
    <v-container class="h-100">
      <v-row justify="center" class="h-100 flex-column" align="center">
        <div class="login-card">
          <div class="secure-oneid">
            <img
              src="../../assets/padlock.png"
              class="mr-2"
              width="12px"
              alt=""
              height="auto"
            />รองรับความปลอดภัยโดย
            <img
              src="../../assets/logo-oneid_grey.png"
              class="ml-2"
              alt=""
              height="auto"
              width="40px"
            />
          </div>
          <div class="title-login">
            <div class="logo">
              <img src="../../assets/apiIcon2.png" draggable="false" alt width="120px" height="auto" />
            </div><br/>
            <div class="title-main" v-if="e1 === 1">การกู้คืนบัญชี</div>
            <div class="title-main" v-if="e1 === 2">
              นี่เป็นบัญชีผู้ใช้ของคุณใช่หรือไม่?
            </div>
            <div class="title-main" v-if="e1 === 3">ยืนยันรหัส OTP?</div>
            <div class="title-main" v-if="e1 === 4">
              การกู้คืนบัญชีผ่านอีเมล
            </div>
            <div class="title-main" v-if="e1 === 5">สร้างรหัสผ่านใหม่</div>
            <div class="title-sub" v-if="e1 === 1">
              กรอกชื่อผู้ใช้ของคุณเพื่อกู้คืนบัญชี
            </div>
            <div class="title-sub" v-if="e1 === 2">
              กรอกหมายเลขโทรศัพท์มือถือหรืออีเมลของคุณเพื่อส่งรหัสยืนยัน
            </div>
            <div class="title-sub" v-if="e1 === 3">
              กรอกรหัส OTP ที่คุณได้รับเพื่อทำการสร้างรหัสผ่านใหม่
            </div>
            <div class="title-sub" v-if="e1 === 4">
              โปรดตรวจสอบอีเมลของคุณเพื่อสร้างรหัสผ่านใหม่
            </div>
            <div class="title-sub" v-if="e1 === 5">
              สร้างรหัสผ่านใหม่ที่คุณต้องการได้เลย
            </div>
          </div>

          <v-stepper v-model="e1" alt-labels>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="username"
                      label="ชื่อผู้ใช้"
                      class="mt-2"
                      placeholder="กรุณากรอก Username"
                      outlined
                      Solo
                      dense
                      @input="checkUserName"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <div class="btn-step-group">
                  <span></span>
                  <v-btn
                    :disabled="disableUserName"
                    small
                    color="#71B842"
                    class="btn-login"
                    height="40px"
                    style="padding:0 36px !important"
                    @click="e1 = 2"
                    >ถัดไป</v-btn
                  >
                </div>
              </v-stepper-content>

              <v-stepper-content step="2">
                <transition name="fade">
                  <v-row class="mt-2" v-if="disabledTel">
                    <v-col md="12" xs="12" class="py-0">
                      <v-text-field
                        v-model="telForgot"
                        label="หมายเลขโทรศัพท์มือถือ"
                        placeholder="08 1111 1111"
                        outlined
                        v-mask="'## #### ####'"
                        hide-details
                        dense
                        @input="checkTypeForgot"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </transition>
                <transition name="fade">
                  <div
                    class="d-flex justify-center or"
                    v-if="telForgot == 0 && emailForgot == 0"
                  >
                    หรือ
                  </div>
                </transition>
                <transition name="fade">
                  <v-row class="mt-5" v-if="disabledEmail">
                    <v-col md="12" xs="12" class="py-0">
                      <v-text-field
                        v-model="emailForgot"
                        label="อีเมล"
                        placeholder="กรอกอีเมลของคุณ"
                        outlined
                        type="email"
                        dense
                        @input="checkTypeForgot"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </transition>
                <div class="btn-step-group">
                  <v-btn text @click="e1 = 1">ย้อนกลับ</v-btn>
                  <v-btn
                    small
                    color="#71B842"
                    class="btn-login"
                    height="40px"
                    style="padding:0 36px !important"
                    :disabled="sendPassConfirm"
                    @click="selectMethodForgot"
                    >ส่งรหัสยืนยัน</v-btn
                  >
                </div>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-row>
                  <v-col>
                    <label>หมายเลขโทรศัพท์ของคุณ</label>
                    <div class="input-warpper">
                      <input
                        class="custom-input display-input"
                        v-model="tel"
                        disabled
                      />
                      <!-- <span
                      class="countinside-input"
                      :style="{ cursor: vcursor }"
                      >{{ otp_remaining }}</span
                    > -->
                      <div
                        class="countinside-input"
                        :style="{ cursor: vcursor }"
                        @click="send_OTP"
                      >
                        {{ otp_remaining }}
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="votp"
                      label="รหัส OTP"
                      placeholder="กรอกรหัส OTP"
                      outlined
                      hide-details
                      type="email"
                      dense
                      @input="checkTypeCreatePass"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <div class="btn-step-group">
                  <v-btn text @click="e1 = 2">ย้อนกลับ</v-btn>
                  <v-btn
                    small
                    color="#71B842"
                    class="btn-login"
                    height="40px"
                    style="padding:0 36px !important"
                    :disabled="createPassBtn"
                    @click="toConfirmPass"
                    >สร้างรหัสผ่านใหม่</v-btn
                  >
                </div>
              </v-stepper-content>

              <v-stepper-content step="4">
                <v-row>
                  <v-col>
                    <label>อีเมลของคุณ</label>
                    <div class="input-warpper">
                      <!-- <input class="custom-input display-input" v-model="emailForgot"/> -->
                      <input class="custom-input" v-model="emailForgot" />
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col></v-col>
                </v-row>
                <div class="btn-step-group">
                  <v-btn text @click="e1 = 2">ย้อนกลับ</v-btn>
                </div>
              </v-stepper-content>

              <v-form ref="step5_form" v-model="step5_valid" lazy-validation>
                <v-stepper-content step="5" class="custom-text-field">
                  <v-row class="mt-5">
                    <v-col>
                      <transition name="fade">
                        <v-text-field
                          v-model="newPass1"
                          :rules="newPass1_rules"
                          label="รหัสผ่านใหม่"
                          placeholder="กรอกรหัสผ่านใหม่ของคุณ"
                          outlined
                          :type="checkboxNew1 ? 'text' : 'password'"
                          :append-icon="checkboxNew1 ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="checkboxNew1 = !checkboxNew1"
                          dense
                        >
                        </v-text-field>
                      </transition>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="newPass2"
                        :rules="[checkNotEmpty, newPass2_rules]"
                        label="ยืนยันรหัสผ่านใหม่"
                        placeholder="กรอกรหัสผ่านใหม่ของคุณอีกครั้ง"
                        outlined
                        :type="checkboxNew2 ? 'text' : 'password'"
                        :append-icon="checkboxNew2 ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="checkboxNew2 = !checkboxNew2"
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <div class="btn-step-group">
                    <v-btn text @click="e1 = 2">ย้อนกลับ</v-btn>
                    <v-btn
                      @click="summitNewPassword"
                      small
                      color="#71B842"
                      class="btn-login"
                      height="40px"
                      style="padding:0 36px !important"
                      >ยืนยันรหัสผ่านใหม่</v-btn
                    >
                  </div>
                </v-stepper-content>
              </v-form>
            </v-stepper-items>
          </v-stepper>
        </div>
        <div class="no-account">หากคุณมีบัญชีผู้ใช้แล้ว</div>
        <div class="btn-register">
          <router-link to="/login">ลงชื่อเข้าใช้</router-link>
        </div>
      </v-row>
      <!-- <b-modal id="modal-success" hide-header hide-footer no-close-on-backdrop no-close-on-esc>
        <div class="d-block text-center">
          <div class="iconCorrect">
            <v-icon dark color="#01b901" size="120">
              mdi-checkbox-marked-circle
            </v-icon>
            <div class="text-center pt-3 title" style="font-size:35px">
              เปลี่ยนรหัสผ่านเรียบร้อยแล้ว
            </div>
            <div class="pt-3">
              <v-row class="text_style">
                <v-col>
                  <b-button class="but-text" variant="success" @click="toLogin"
                    >ตกลง</b-button
                  >
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </b-modal> -->
      <b-modal id="modal-success" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
        <div class="d-block text-center mt-4">
          <v-icon color="#71B842" right dark size="90">mdi-checkbox-marked-circle</v-icon>
          <center>
            <label class="mt-4 title_modal"
              >สร้างรหัสผ่านใหม่เรียบร้อยแล้ว </label
            >
              <label class="mt-3 text_modal"
              >ลงชื่อเข้าใช้อีกครั้ง หลังจากนั้นคุณจะสามารถเริ่มใช้บริการ</label
            >
              <label class="text_modal"
              >ประทับรับรองเวลาอิเล็กทรอนิกส์ได้เลยทันที</label
            >
          </center>
        </div>
        <v-row class="">
          <v-col>
            <div class="title_modal text-center">
              <b-button class="" variant="success text-white" @click="$router.push({path:'/login'})"
                >ลงชื่อเข้าใช้</b-button
              >
            </div>
          </v-col>
        </v-row>
      </b-modal>
    </v-container>
    <v-snackbar
      v-model="snackbar_OTP"
      color="#D50000"
      :top="true"
      :timeout="5000"
    >
      ชื่อผู้ใช้ หรือหมายเลขโทรศัพท์ ไม่ถูกต้อง
      <template v-slot:action="{ attrs }">
        <v-btn color="right" outlined text @click="snackbar_OTP = false" v-bind="attrs">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <!-- <v-snackbar
      v-model="snackbar_email"
      color="#D50000"
      :top="true"
      :timeout="5000"
    >
      ชื่อผู้ใช้ หรืออีเมล ไม่ถูกต้อง
      <v-btn color="right" outlined  @click="snackbar_email = false">
        Close
      </v-btn>
    </v-snackbar> -->
    <v-snackbar v-model="snackbar_email" color="#D50000" :top="true" :timeout="5000">
      ชื่อผู้ใช้ หรืออีเมล ไม่ถูกต้อง
      <template v-slot:action="{ attrs }">
        <v-btn color="right" text @click="snackbar_email = false" v-bind="attrs">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "ForgotPasswordComponent",
  data: () => ({
    e1: 1,
    mobile: window.innerWidth <= 880,

    otpcount: "",
    username: "",
    otp_remaining: "",
    tel: "",
    email: "",
    vcursor: "text",
    telForgot: "",
    phoneNum: "", //ส่งหลังบ้าน
    emailForgot: "",
    otp: "",
    votp: "",
    newPass1: "",
    newPass2: "",

    snackbar_OTP: false,
    snackbar_email: false,
    step5_valid: true,
    disabledTel: true,
    disabledEmail: true,
    createPassBtn: true,
    sendPassConfirm: true,
    checkboxNew1: false,
    checkboxNew2: false,
    disableUserName: true,
    
    newPass1_rules: [
      (v) => !!v || "กรุณาใส่ รหัสผ่าน",
      (v) =>
        /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,32}$/.test(v) ||
        "รหัสผ่านต้องประกอบด้วย ตัวอักษรภาษาอังกฤษ a-z, A-Z ตัวเลข0-9 และมีความยาวต้องไม่น้อยกว่า 8 ตัวอักษร เท่านั้น!",
    ],
  }),
  created() {
    addEventListener('resize', () => {
      this.mobile = innerWidth <= 880
    })
  },
  computed: {
    newPass2_rules() {
      return () => this.newPass2 === this.newPass1 || "รหัสผ่านไม่ตรงกัน";
    },
    checkNotEmpty() {
      return (v) => !!v || "กรุณาใส่ รหัสผ่าน";
    },
  },
  watch: {
    telForgot(value) {
      this.telForgot = value;
    },
    emailForgot(value) {
      this.emailForgot = value;
    },
    votp(value) {
      this.votp = value;
    },
  },
  methods: {
    toLogin: function() {
      this.$router.push({ path: "/login" });
    },
    toConfirmPass: function() {
      this.e1 = 5;
    },
    counterOTP: function(count) {
      this.otpcount = setInterval(() => {
        this.otp_remaining =
          count != 0
            ? `ส่งรหัส OTP อีกครั้งในอีก ${count} วินาที`
            : `ส่งรหัส OTP อีกครั้ง`;
        count-- || clearInterval(this.otpcount);
        count == 0 ? (this.vcursor = "pointer") : "text";
      }, 1000);
      // clearInterval(otpcount);
      // console.log(otpcount);
    },
    activateOTP: function() {
      clearInterval(this.otpcount);
      if (this.e1 == 3) {
        this.otp_remaining = "";
        this.vcursor = "text";
        this.counterOTP(300);  //5 นาที
        this.tel = this.telForgot;
      }
    },
    selectMethodForgot: function() {
      if (this.telForgot.length > 0 && this.emailForgot.length == 0) {
        this.e1 = 3;
        this.send_OTP();
      } else if (this.emailForgot.length > 0 && this.telForgot.length == 0) {
        // this.e1 = 4;
        if (this.emailForgot.length > 0 && this.telForgot.length == 0) {
          // console.log("อีเมล");
          //api email ส่งรหัสยืนยัน
          axios({
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            url: process.env.VUE_APP_API_RESET_PASSWORD_BY_EMAIL,
            data: {
              username: this.username,
              email: this.emailForgot,
            },
          })
            .then((response) => {
              // console.log("response" + JSON.stringify(response));
              if (
                response.data.errorMessage == "username and email not found."
              ) {
                this.snackbar_email = true;
                this.e1 = 2;
              } else {
                this.e1 = 4;
              }
            })
            .catch((error) => {
              console.log(error);
              this.snackbar_email = true
              this.e1 = 2;
            });
        }
      } else {
        this.e1 = 5;
      }
    },
    //api ส่ง OTP
    send_OTP: function() {
      this.activateOTP();
      this.phoneNum = this.telForgot.replace(/ /g, "");
      // this.e1 = 3;
      this.votp = "";
      this.createPassBtn = true;
      const accessToken = localStorage.getItem('access_token')
      axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + accessToken
        },
        url: process.env.VUE_APP_API_SEND_OTP,
        data: {
          username: this.username,
          tel_no: this.phoneNum,
        },
      })
        .then((response) => {
          console.log("response" + JSON.stringify(response));
          if (response.data.errorMessage == "username and Tel not found") {
            this.snackbar_OTP = true
            this.e1 = 2;
          } else if (response.data.errorMessage == null) {
            this.e1 = 3;
          } else {
            this.snackbar_OTP = true
            this.e1 = 2;
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar_OTP = true
          this.e1 = 2;
        });
    },
    checkUserName: function() {
      if (this.username.length > 0) {
        this.disableUserName = false;
      } else {
        this.disableUserName = true;
      }
    },
    checkTypeForgot: function() {
      // eslint-disable-next-line no-console
      //console.log(this.telForgot.length,this.emailForgot.length);
      if (this.telForgot.length > 0 && this.emailForgot.length == 0) {
        this.disabledEmail = false;
        this.disabledTel = true;
        this.sendPassConfirm = false;
      } else if (this.emailForgot.length > 0 && this.telForgot.length == 0) {
        this.disabledTel = false;
        this.disabledEmail = true;
        this.sendPassConfirm = false;
      } else {
        this.disabledTel = true;
        this.disabledEmail = true;
        this.sendPassConfirm = true;
      }
    },
    checkTypeCreatePass: function() {
      // eslint-disable-next-line no-console
      // console.log(this.votp.length);
      if (this.votp.length === 6) {
        this.createPassBtn = false;
      }
      if (this.email.length > 0) {
        this.createPassBtn = false;
      }
    },
    summitNewPassword: function() {
      if (this.$refs.step5_form.validate()) {
        // this.$bvModal.show("modal-success");

        if (this.telForgot.length > 0 && this.emailForgot.length == 0) {
          //api เบอร์โทร ส่งรหัสยืนยัน
          axios({
            method: "post",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            url: process.env.VUE_APP_API_RESET_PASSWORD_BY_OTP,
            data: {
              otp: this.votp,
              new_password: this.newPass1,
              confirm_new_password: this.newPass2,
            },
          })
            .then((response) => {
              // console.log("response" + JSON.stringify(response));
              // console.log(response);
              if (response.data.result == "Fail") {
                alert("เกิดข้อผิดพลาดกรุณาตรวจสอบ ชื่อผู้ใช้ หรือ รหัส OTP");
              } else {
                this.$bvModal.show("modal-success");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-text-field::v-deep .v-text-field__details {
  margin-bottom: 8px;
  position: absolute;
  top: 50px;
}
.h-100 {
  height: 100%;
}
.login-card {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  width: 600px;
  transition: all 0.5s;
  padding: 24px 10px;
  background: #fff;
  position: relative;
}

.secure-oneid {
  position: absolute;
  right: 16px;
  top: 16px;
  font-size: 10px;
  color: #a5a5a5;
  display: flex;
  align-items: center;
}

.title-main {
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.43px;
  color: #464646;
  text-align: center;
  margin-bottom: 8px;
}
.title-sub {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.29px;
  text-align: center;
  color: #8e8e93;
  text-align: center;
  margin-bottom: 24px;
}

.logo {
  text-align: center;
}

.logo img {
  width: 200px;
}
.v-text-field {
  min-height: 20px;
  height: 60px;
}

.checkbox-password svg {
  width: 16px;
}

.checkbox-password label {
  font-size: 13px;
  color: #bdbdbd;
}

.checkbox-password div:first-child {
  margin: 0;
  height: 0;
}

.checkbox-password {
  margin-top: -5px;
}

.btn-login {
  padding: 8px !important;
  color: #fff !important;
  font-size: 16px !important;
}

.forgot-password {
  margin-top: 16px;
  text-align: end;
  color: #71B842;
  cursor: pointer;
}

.no-account {
  margin-top: 12px;
  color: #8e8e93;
  font-size: 12px;
}

.btn-register {
  margin-top: 12px;
  color: #8e8e93;
  font-size: 14px;
  color: #71B842;
}

.btn-step-group {
  display: flex;
  justify-content: space-between;
}

.mt-50 {
  margin-top: 60px;
}

.or {
  color: #8e8e93;
}

.display-input {
  border: 0;
}

.input-warpper {
  position: relative;
}

.countinside-input {
  position: absolute;
  right: 24px;
  top: 8px;
}
.title_modal {
  font-family: Prompt;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--greyish-brown);
}
.text_modal {
  font-family: Prompt;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.21px;
  text-align: center;
  color: #8e8e93;
}
</style>
<style>
.v-stepper__header {
  box-shadow: none !important;
}

.v-stepper {
  box-shadow: none !important;
}

.v-stepper__content {
  padding: 0px 24px 0px 24px !important;
}

.but-text {
  font-family: Prompt;
  font-size: 18px;
  width: 100px;
  height: 40px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}
.text_alert {
  font-family: Prompt;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #666666;
}
.title {
  font-family: Prompt;
  font-size: 32px;
  font-weight: 500; 
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #282828;
}
.title_alert {
  text-align: center;
  font-family: Prompt;
  font-size: 36px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--greyish-brown);
}
.iconCorrect {
  text-align: center;
}
@media screen and (max-width: 880px) {
  .btn-step-group {
    justify-content: center !important;
    border-radius: 24px;
  }
  .btn-login {
    border-radius: 24px;
    padding: 0px 17px !important;
  }
  .login-card {
    width: auto !important;
  }
}
</style>
